'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _bubbleMenu = require('common/components/bubble-menu');

var _bubbleMenu2 = _interopRequireDefault(_bubbleMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// In-app footer
var AppFooter = _react2['default'].createClass({
    displayName: 'AppFooter',


    propTypes: {
        'siteCode': _react2['default'].PropTypes.string.isRequired // S or F
    },

    SOCIAL_NAMES: ['linkedin', 'fb', 'twitter'],
    SOCIAL_URLS: {
        'twitter': 'https://twitter.com/hellosign',
        'fb': 'https://www.facebook.com/hellosignapp',
        'linkedin': 'https://www.linkedin.com/company/hellosign'
    },

    getInitialState: function getInitialState() {
        return {
            'showProductMenu': false,
            'showFinePrintMenu': false
        };
    },

    componentDidMount: function componentDidMount() {
        var root = $(_reactDom2['default'].findDOMNode(this));
        $('.product-link', root).hover(this.toggleProductMenu);
        $('.fine-print-link', root).hover(this.toggleFinePrintMenu);
    },

    toggleProductMenu: function toggleProductMenu(evt) {
        var show = !this.state.showProductMenu;
        this.setState({
            'showProductMenu': show
        });
    },

    toggleFinePrintMenu: function toggleFinePrintMenu(evt) {
        var show = !this.state.showFinePrintMenu;
        this.setState({
            'showFinePrintMenu': show
        });
    },

    render: function render() {

        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
        var isHf = _hfReactHelper2['default'].HfSites.isHelloFax(this.props.siteCode);
        var securityUrl = _hfReactHelper2['default'].urlHelper('info/security', site);
        var pricingUrl = _hfReactHelper2['default'].urlHelper('info/pricing', site);
        var homeUrl = _hfReactHelper2['default'].urlHelper('home/index', site);
        var faqUrl = isHf ? 'http://faq.hellosign.com/hc/en-us/categories/200353237-HelloFax-Help' : 'http://faq.hellosign.com';
        var hfHomeUrl = _hfReactHelper2['default'].urlHelper('home/bridge/to/F', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);
        var hsHomeUrl = _hfReactHelper2['default'].urlHelper('home/bridge/to/S', _hfReactHelper2['default'].HfSites.SITE_CODE_HF);
        var bridgeUrl = isHf ? hsHomeUrl : hfHomeUrl;

        var socialImageUrls = {
            twitter: require('./twitter@2x.png'),
            fb: require('./fb@2x.png'),
            linkedin: require('./linkedin@2x.png')
        };

        // Social links
        var name;
        var social = [];
        for (var i in this.SOCIAL_NAMES) {
            name = this.SOCIAL_NAMES[i];
            social.push(_jsx('div', {
                className: 'm-app-footer--social--icon'
            }, 'social-' + i, _jsx('a', {
                href: this.SOCIAL_URLS[name],
                target: '_blank'
            }, void 0, _jsx('img', {
                className: 'm-app-footer--social--icon--img',
                src: socialImageUrls[name]
            }))));
        }

        // Product menu
        var productMenu;
        if (this.state.showProductMenu) {
            var items = [isHf ? undefined : _jsx('a', {
                href: _hfReactHelper2['default'].urlHelper('api', site)
            }, void 0, 'API'), isHf ? undefined : _jsx('a', {
                href: _hfReactHelper2['default'].urlHelper('gmail', site)
            }, void 0, 'Gmail'), _jsx('a', {
                href: _hfReactHelper2['default'].urlHelper('googledocs', site)
            }, void 0, 'Google Docs'), _jsx('a', {
                href: _hfReactHelper2['default'].urlHelper('googledrive', site)
            }, void 0, 'Google Drive'), isHf ? undefined : _jsx('a', {
                href: _hfReactHelper2['default'].urlHelper('info/mobile', site)
            }, void 0, 'Mobile'), _jsx('a', {
                href: bridgeUrl,
                target: '_blank'
            }, void 0, 'Hello' + (isHf ? 'Sign' : 'Fax'))];
            productMenu = _jsx(_bubbleMenu2['default'], {
                items: items,
                direction: 'top',
                className: 'product-menu'
            }, 'products-popup');
        }

        // Fine print menu
        var finePrintMenu;
        if (this.state.showFinePrintMenu) {
            var items = [_jsx('a', {
                href: _hfReactHelper2['default'].urlHelper('info/security', site)
            }, void 0, 'Security'), _jsx('a', {
                href: _hfReactHelper2['default'].urlHelper('info/legal', site)
            }, void 0, 'Legal'), _jsx('a', {
                href: _hfReactHelper2['default'].urlHelper('info/privacyPolicy', site)
            }, void 0, 'Privacy'), _jsx('a', {
                href: _hfReactHelper2['default'].urlHelper('info/tos', site)
            }, void 0, 'Terms')];
            finePrintMenu = _jsx(_bubbleMenu2['default'], {
                items: items,
                direction: 'top',
                className: 'fine-print-menu'
            }, 'fine-print-popup');
        }

        return _jsx('div', {
            className: 'm-app-footer row'
        }, void 0, _jsx('div', {
            className: 'm-app-footer--logo'
        }, void 0, _jsx('a', {
            href: homeUrl
        }, void 0, _jsx('img', {
            className: 'm-app-footer--logo--img',
            src: isHf ? require('./hf_icon@2x.png') : require('./hs_icon@2x.png')
        }))), _jsx('div', {
            className: 'm-app-footer--links'
        }, void 0, _jsx('div', {
            className: 'm-app-footer--links--link'
        }, void 0, _jsx('a', {
            href: pricingUrl
        }, void 0, 'Pricing')), _jsx('div', {
            className: 'm-app-footer--links--link product-link'
        }, void 0, productMenu, _jsx('a', {
            href: 'javascript:;'
        }, void 0, 'Products')), _jsx('div', {
            className: 'm-app-footer--links--link fine-print-link'
        }, void 0, finePrintMenu, _jsx('a', {
            href: 'javascript:;'
        }, void 0, 'Fine print')), _jsx('div', {
            className: 'm-app-footer--links--link'
        }, void 0, _jsx('a', {
            href: 'javascript:;',
            id: 'footer_help'
        }, void 0, 'Help')), _jsx('div', {
            className: 'm-app-footer--links--link'
        }, void 0, _jsx('a', {
            href: faqUrl,
            target: '_blank'
        }, void 0, 'FAQ'))), _jsx('div', {
            className: 'm-app-footer--social'
        }, void 0, social));
    }

});

module.exports = AppFooter;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/footer/index.jsx
 ** module id = 711
 ** module chunks = 0
 **/